var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('basic-dialog',{attrs:{"id":"inactive-dialog","title":"Logged out","primaryButton":"OK","primaryClick":_vm.close}},[_c('p',{staticClass:"usa-prose mb-0"},[_vm._v("You have been logged out due to inactivity.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }